import { useMemo } from 'react';

import { File } from '../../api/content';
import { ImageSize, formatMediaUrl, isFile } from '../utils';

export function useImageUrl(src: File | string, size?: ImageSize) {
  return useMemo(() => (isFile(src) ? formatMediaUrl(src, size) : src), [src, size]);
}
